export const getPromptsFileName = (state) => {
    return state.promptsFile.upload.uploadedAs ? state.promptsFile.upload.uploadedAs : '';
};
